/**
 * @generated SignedSource<<ba8fc0e05ef1a7a55508b8adc9c086df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateInstructionMutation$variables = {
  body: string;
  teamId?: any | null | undefined;
};
export type UpdateInstructionMutation$data = {
  readonly updateInstruction: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly instruction: {
        readonly body: string;
        readonly id: any;
      };
    } | null | undefined;
  };
};
export type UpdateInstructionMutation = {
  response: UpdateInstructionMutation$data;
  variables: UpdateInstructionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "body"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "body",
        "variableName": "body"
      },
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      }
    ],
    "concreteType": "UpdateInstructionResponse",
    "kind": "LinkedField",
    "name": "updateInstruction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateInstructionSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLInstruction",
            "kind": "LinkedField",
            "name": "instruction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateInstructionError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateInstructionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateInstructionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf391619258043bf30bbfc331bc4cfde",
    "id": null,
    "metadata": {},
    "name": "UpdateInstructionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateInstructionMutation(\n  $body: String!\n  $teamId: GlobalID\n) {\n  updateInstruction(body: $body, teamId: $teamId) {\n    success {\n      instruction {\n        id\n        body\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91360d4a1f1f4bd3d7508323433442a2";

export default node;
